import { HttpClient } from '@angular/common/http';
import { Injectable , NgZone} from '@angular/core';
import { environment } from 'src/environments/environment';
import {  Subject } from 'rxjs';
declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleLoginService {

  public auth2: any;
  googleSignIn: Promise<any>;
  googleSignInUrl: string = 'https://accounts.google.com/gsi/client';
  accessGoogleSignIn: boolean = false;
  resolve: any;

  credentialdatasource: Subject <any> = new Subject<any>(); // Source
  get credentialDataObservable() {
    return this.credentialdatasource.asObservable();
  }
  constructor(private http: HttpClient,private ngZone: NgZone) { }

  initGoogleSignIn (element: any,isSignupForm:boolean) {
    this.googleSignIn = new Promise((resolve) => {
      this.loadGoogleSignIn();
      setTimeout(() => {
        this.accessGoogleSignIn = true;
        this.googleInit(element,isSignupForm);
        resolve(true);
      }, 200);
    });
  }

  loadGoogleSignIn () {
    let node = document.createElement('script');
    node.src = this.googleSignInUrl;
    node.type = 'text/javascript';
    node.async = false;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  
  public googleInit(element,isSignupForm) {
      if(window.google){
        window.google.accounts.id.initialize({
            client_id: environment.googleOauthClientId,
            
              callback: this.handleCredentialResponse.bind(this)
          
          })
          window.google.accounts.id.renderButton(element,{
              type:"standard",
              text:isSignupForm?"signup_with":"signin_with",
              theme: "filled_blue",
              size: 'medium', 
              shape: "rectangular",
              width: 200
          });
          // window.google.accounts.id.prompt();
       
    }
    else{
        setTimeout(() => this.googleInit(element,isSignupForm), 200);
    }
  }

  public handleCredentialResponse(user){
    this.ngZone.run(()=>{
      const responsePayload=user.credential;
      this.credentialdatasource.next(responsePayload);
    })
    
  }


}